import { Component, Input, OnInit, Output, EventEmitter, forwardRef, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { BaseServiceService } from "src/app/services/base-service.service";

declare var fabric: any;

@Component({
  selector: 'app-combo-box',
  templateUrl: './combo-box.component.html',
  styleUrl: './combo-box.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboBoxComponent), // Do tên class nằm phía dưới khi gọi cần dùng forwardRef
      multi: true,
    }
  ]
})
export class ComboBoxComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() label: string;
  @Input() required: boolean;
  @Input() formControlName: string;
  @Input() type: string;
  @Input() classField: string;
  @Input() frm: FormGroup;
  @Input() searchable: boolean = false;
  modelo: any;
  searchableData: any[];
  searchableBindValue: string;
  searchableLabelForId: string;

  constructor(private baseService: BaseServiceService) {}

  ngOnInit(): void {

  }
  
  async ngAfterViewInit(): Promise<void> {
    
    const data = await this.getItems();
    this.setItems(data);
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this.modelo;
  }

  set value(val) {
    
    this.modelo = val;
    this.onChange(val);
    this.onTouched();

  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  get ctrlInvalid() {

    return this.frm.controls[this.formControlName]['invalid'];
  }
  
  get ctrlTouched() {

    return this.frm.controls[this.formControlName]['touched'];

  }

  async getItems() {

    console.log("."+this.classField);
    var endpoint = '';
    var textData = '';
    var valueData = '';

    switch(this.type)
    {
      case 'role':
        endpoint = 'RolUsuario/ListaRolesActivos';
        textData = 'NombreRol';
        valueData = 'Id';
        break;
      
      case 'idType':
        endpoint = 'DatoBasico/ListaTipoIdentificacion';
        textData = 'Nombre';
        valueData = 'Id';
        break;
      
      case 'process':
        endpoint = 'Proceso/ListaProcesos';
        textData = 'Nombre';
        valueData = 'Id';
        break;
    }

    try {
      const response = await this.baseService
        .getAll(endpoint)
        .toPromise();
      return { data: response.Data, textData: textData, valueData: valueData };
    } catch (error) {}
  }

  setItems(data)
  {

    try
    {

      if(this.searchable)
      {
        this.searchableData = data['data'];
        this.searchableBindValue = data['valueData'];
        this.searchableLabelForId = data['textData'];
      }
      else
      {
        const selectElement = document.querySelector(
          "."+this.classField
        ) as HTMLSelectElement;
        selectElement.innerHTML = "<option value=''>Seleccione&hellip;</option>";
  
        data['data'].forEach((element) => {
          const option = document.createElement("option");
          option.textContent = element[data['textData']];
          option.value = element[data['valueData']];
  
          selectElement.appendChild(option);
        });
        this.initializeFabric();
      }

      

    } catch (error) {}

  }

  initializeFabric() {
    var DropdownHTMLElements = document.querySelectorAll(".dropdown");
    for (var i = 0; i < DropdownHTMLElements.length; ++i) {
      var Dropdown = new fabric["Dropdown"](DropdownHTMLElements[i]);
    }
  }

}
